module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo05-d488b37d132950d44d23d788945d077f.png";